import * as React from 'react';
import { ActionLink } from '@cian/ui-kit';
import { IconFilePrint16 } from '@cian/ui-kit-design-tokens/icons';

export const PrintButtonContainer: React.FC = () => {
  const printDocument = React.useCallback(() => {
    window.print();
  }, []);

  return (
    <ActionLink
      onClick={printDocument}
      beforeIcon={<IconFilePrint16 color="current_color" />}
      type="button"
      fontWeight="bold"
      fontSize="M"
    >
      Распечатать предложения
    </ActionLink>
  );
};
